import React, { useState } from 'react';
import AccordionItem from '@/atomic/atoms/AccordionItem';

interface AccordionListItem {
  title: string;
  text?: string;
  element?: string;
}

interface AccordionListProps {
  items: AccordionListItem[];
}

const AccordionList: React.FC<AccordionListProps> = ({ items }) => {
  const [openedIndex, setOpenedIndex] = useState<number | null>(null);

  return (
    <>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          isOpen={openedIndex === index}
          onToggle={() => setOpenedIndex(openedIndex === index ? null : index)}
          element={item.element}
        >
          {item.text && (
            <p className="text-base text-gray-500">
              {item.text.split("\n").map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          )}
        </AccordionItem>
      ))}
    </>
  );
};

export default AccordionList; 